define('TescoMobile_AciPayment/js/view/card-payment-step',['jquery', 'ko', 'underscore', 'uiRegistry', 'mage/translate', 'mage/url', 'Magento_Ui/js/form/form', 'Magento_Checkout/js/model/checkout-data-resolver', 'Magento_Checkout/js/checkout-data', 'Magento_Checkout/js/model/quote', 'Magento_Checkout/js/model/step-navigator', 'Magento_Checkout/js/model/full-screen-loader', 'Magento_Customer/js/model/customer', 'TescoMobile_Checkout/js/action/get-card-payment', 'TescoMobile_Checkout/js/model/payment-information', 'TescoMobile_Checkout/js/model/card-details-step-visibility', 'Magento_Checkout/js/model/error-processor', 'TescoMobile_AciPayment/js/action/store-payment-info'], function ($, ko, _, registry, $t, urlBuilder, Component, checkoutDataResolver, checkoutData, quote, stepNavigator, fullScreenLoader, customer, getCardPaymentAction, paymentInformation, stepVisibility, errorProcessor, storePaymentInfo) {
  'use strict';

  var _window$checkoutConfi;
  const tescoConfig = (_window$checkoutConfi = window.checkoutConfig) === null || _window$checkoutConfi === void 0 ? void 0 : _window$checkoutConfi.tescomobile,
    aci = tescoConfig === null || tescoConfig === void 0 ? void 0 : tescoConfig.aci,
    cardDetails = tescoConfig === null || tescoConfig === void 0 ? void 0 : tescoConfig.card_details;
  return Component.extend({
    defaults: {
      template: 'TescoMobile_AciPayment/card-payment-step',
      visible: false,
      apiVersion: 'V1',
      widgetInitialized: false,
      shopperResultUrl: null,
      forceStoreCard: false,
      storeCardForFutureLabel: 'Please store my card for future use *',
      storeCardForFutureFootnotes: '*This card can be used for future ad-hoc payments & any required refunds.',
      cardTransactionSoftDescriptorMessage: 'Please be aware, your payments will show on your bank or credit card statements as Tesco Mobile.',
      wpwlOptions: {
        style: "plain",
        requireCvv: false,
        shopperResultTarget: 'aciCardPaymentFrame',
        paymentTarget: 'aciCardPaymentFrame',
        brandDetection: true,
        threeDIframeSize: {
          width: '1px',
          height: '1px'
        }
      },
      checkboxPreSelected: true
    },
    hasStoredCard: (cardDetails === null || cardDetails === void 0 ? void 0 : cardDetails.has_stored_card) || false,
    hasExpiredCard: (cardDetails === null || cardDetails === void 0 ? void 0 : cardDetails.has_expired_card) || false,
    cardDetails: {},
    showAci: ko.observable(false),
    errorMessage: 'Sorry, we seem to be having some technical problems at the moment. We have not taken any payment. Please go back to your basket to start checkout again.',
    errorMessageRetryLimit: 'Please go back to your basket to start checkout again.',
    paymentError: false,
    canRetryPayment: false,
    retryLimitExceeded: false,
    initialize: function () {
      this._super();
      if (stepVisibility.canShow()) {
        stepNavigator.registerStep('card-payment', 'card-payment', $t('Card details'), this.visible, _.bind(this.navigate, this), this.sortOrder);
      }
      this.showAci(!customer.isLoggedIn() || customer.isLoggedIn() && !this.hasStoredCard);
      this.showStoredCard = ko.computed(function () {
        return customer.isLoggedIn() && this.hasStoredCard && !this.showAci();
      }.bind(this));
      this.visible.subscribe(this.onVisibilityChange, this);
      this.shopperResultUrl = this.shopperResultUrl || this.getCardPaymentCaptureUrl();
      return this;
    },
    initObservable: function () {
      return this._super().observe(['visible', 'isCardPaymentProvided', 'cardDetails', 'paymentError', 'canRetryPayment', 'paymentStatus', 'retryLimitExceeded', 'errorMessage']);
    },
    onVisibilityChange: function (value) {
      if (value === true) {
        const messageContainer = registry.get('checkout.errors').messageContainer;
        window.addEventListener('message', this);
        if (this.hasStoredCard) {
          const expiryDate = quote.getData('customer_tm_expiry_date');
          const cardDetails = {
            cardType: quote.getData('customer_tm_card_type'),
            cardNumber: $t('Card ending') + ' ' + quote.getData('customer_tm_card_number').replace(/\*/g, '')
          };
          if (expiryDate && expiryDate.split('+').length > 0) {
            try {
              const formattedExpiryDate = new Date(expiryDate.split('+')[0]);
              cardDetails.expiryDate = new Intl.DateTimeFormat('en-GB', {
                year: '2-digit',
                month: '2-digit'
              }).format(formattedExpiryDate);
            } catch (e) {
              cardDetails.expiryDate = '';
            }
          } else {
            cardDetails.expiryDate = '';
          }
          this.cardDetails(cardDetails);
        }
        if (!this.showStoredCard()) {
          fullScreenLoader.startLoader();
          getCardPaymentAction(this.apiVersion).done(function (checkoutId) {
            this.initAciWidget(checkoutId);
          }.bind(this)).fail(function (response) {
            if (response.status === 500) {
              errorProcessor.process(response, messageContainer);
              this.unloadAciWidget();
              stepNavigator.previousStep();
            } else {
              this.paymentStatus({
                status: 'success'
              });
            }
          }.bind(this)).always(function () {
            fullScreenLoader.stopLoader();
          });
        }
      } else {
        this.unloadAciWidget();
        window.removeEventListener('message', this);
      }
    },
    handleEvent: function (event) {
      if (event.origin !== window.BASE_URL.replace(/\/$/, '')) {
        return;
      }
      const messageContainer = registry.get('checkout.errors').messageContainer;
      let self = this;
      if ($('#storeCardForFuture').length === 0) {
        self.paymentStatus(event.data);
        return;
      }
      let isChecked = $('#storeCardForFuture').is(':checked');
      if (!customer.isLoggedIn()) {
        storePaymentInfo(isChecked, quote.getQuoteId()).done(function (response) {
          if (response === false) {
            messageContainer.addErrorMessage({
              message: $t('Current quote has no payment detail.')
            });
          }
        }).fail(function () {
          messageContainer.addErrorMessage({
            message: $t('Something went wrong, please try again.')
          });
        }).always(function () {
          self.paymentStatus(event.data);
        });
      }
    },
    navigate: function (step) {
      step && step.isVisible(true);
    },
    getCardPaymentCaptureUrl: function () {
      urlBuilder.setBaseUrl(BASE_URL);
      return urlBuilder.build('tescomobile_aci/checkout/paymentcapture') + '?cartId=' + quote.getQuoteId();
    },
    initAciWidget: function (checkoutId) {
      let self = this;
      window.wpwlOptions = {
        style: self.wpwlOptions.style,
        requireCvv: self.wpwlOptions.requireCvv,
        shopperResultTarget: self.wpwlOptions.shopperResultTarget,
        paymentTarget: self.wpwlOptions.paymentTarget,
        brandDetection: self.wpwlOptions.brandDetection,
        threeDIframeSize: self.wpwlOptions.threeDIframeSize,
        registrations: {
          hideInitialPaymentForms: true
        },
        labels: {
          register: $t('Continue'),
          cardHolder: $t('Cardholder\'s name'),
          cardNumber: $t('Card number'),
          expiryDate: $t('Expiry date'),
          showOtherPaymentMethods: $t('Use a different card'),
          submit: $t('Continue')
        },
        spinner: {
          width: 0
        },
        iframeStyles: {
          'card-number-placeholder': {
            'color': '#c2c2c2',
            'font-size': '15px',
            'font-family': 'Arial',
            'font-weight': 'normal',
            'letter-spacing': '1px',
            'padding-left': '6px'
          },
          'cvv-placeholder': {
            'color': '#c2c2c2',
            'font-size': '15px',
            'font-family': 'Arial',
            'font-weight': 'normal',
            'letter-spacing': '1px',
            'padding-left': '6px'
          }
        },
        onReady: function () {
          $(".wpwl-group-cardNumber").before($(".wpwl-group-cardHolder"));
          $(".wpwl-group-expiry").after($(".wpwl-group-brand"));
          $(".wpwl-control-brand").hide();
          $(".wpwl-label-brand").hide();
          var visa = $(".wpwl-brand:first").clone().removeAttr("class").attr("class", "wpwl-brand-custom wpwl-brand-VISA");
          var master = $(visa).clone().removeClass("wpwl-brand-VISA").addClass("wpwl-brand-MASTER");
          $(".wpwl-brand:first").after($(master)).after($(visa));
          this.widgetInitialized = true;
          $('.wpwl-form-card').find('.wpwl-control-cardHolder').on('change', function (e) {
            self.validateHolder(e);
          });
          if (self.isAciCardFeatureEnabled()) {
            if (!customer.isLoggedIn()) {
              const checkboxPreselectedAttribute = self.checkboxPreSelected ? 'checked="checked"' : '';
              const createRegistrationHtml = '<div class="choice field">' + '<input type="checkbox" name="customParameters[SHOPPER_storeCardForFuture]" id="storeCardForFuture" value="true"' + checkboxPreselectedAttribute + '/>' + '<label for="storeCardForFuture" class="label">' + '<span>' + $t(self.storeCardForFutureLabel) + '</span>' + '<sub>' + $t(self.storeCardForFutureFootnotes) + '</sub>' + '</label></div>';
              $('form.wpwl-form-card').find('.wpwl-button').before(createRegistrationHtml);
            }
            const createCardTransactionSoftDescriptorMessageHtml = '<div class="card-transaction-soft-descriptor-message">' + '<span>' + $t(self.cardTransactionSoftDescriptorMessage) + '</span>' + '</div>';
            $('form.wpwl-form-card').find('.wpwl-button').before(createCardTransactionSoftDescriptorMessageHtml);
          }
          if (self.forceStoreCard) {
            self.applyForceStoringCardToPaymentForm();
          }
          fullScreenLoader.stopLoader();
        }.bind(this),
        onBeforeSubmitCard: function (e) {
          return self.validateHolder(e);
        },
        onChangeBrand: function (e) {
          if (e === 'VISA' || e === 'MASTER') {
            $(".wpwl-brand-custom").css("display", "none");
            $(".wpwl-brand-" + e).css("display", "inline-block");
          } else {
            $(".wpwl-brand-custom").css("display", "inline-block");
          }
        },
        onError: function (error) {
          fullScreenLoader.stopLoader();
          if (error.name === "InvalidCheckoutIdError") {
            const messageContainer = registry.get('checkout.errors').messageContainer;
            messageContainer.addErrorMessage({
              message: $t('Your checkout ID expired. Please try again.')
            });
            this.reloadAciWidget();
          }
        }.bind(this),
        onAfterSubmit: function () {
          fullScreenLoader.startLoader();
        }
      };
      const paymentForm = $('.paymentWidgets');
      if (paymentForm.length === 0) {
        const newForm = document.createElement('form');
        newForm.className = 'paymentWidgets';
        newForm.setAttribute('data-brands', 'VISA MASTER');
        newForm.setAttribute('action', this.shopperResultUrl);
        $('#checkout-step-card-payment').append(newForm);
      }
      fullScreenLoader.startLoader();
      const node = document.getElementsByTagName('script')[0];
      const script = document.createElement('script');
      script.async = true;
      script.src = aci.base_url + '/v1/paymentWidgets.js?checkoutId=' + checkoutId;
      node.parentNode.insertBefore(script, node);
    },
    validateHolder: function () {
      var holder = $('.wpwl-control-cardHolder').val(),
        format = /^[a-zA-Z\-\s]*$/;
      if (!format.test(holder) || holder.trim().length < 2) {
        $('.wpwl-control-cardHolder').addClass('wpwl-has-error').after('<div class="wpwl-hint wpwl-hint-cardHolderError"> ' + $t('Invalid card holder. Letters, space and hyphen only.') + '</div>');
        return false;
      }
      return true;
    },
    reloadAciWidget: function () {
      this.unloadAciWidget();
      getCardPaymentAction(this.apiVersion).done(function (checkoutId) {
        this.initAciWidget(checkoutId);
        fullScreenLoader.stopLoader();
      }.bind(this));
    },
    unloadAciWidget: function () {
      if (window.wpwl !== undefined && window.wpwl.unload !== undefined) {
        window.wpwl.unload();
        $('script').each(function () {
          if (this.src && this.src.indexOf('static.min.js') !== -1) {
            $(this).remove();
          }
        });
        this.widgetInitialized = false;
        if (window.wpwlOptions) {
          delete window.wpwlOptions;
        }
      }
    },
    isAciCardFeatureEnabled: function () {
      return Boolean(aci === null || aci === void 0 ? void 0 : aci.card_future_use_enabled);
    },
    saveCardDetails: function () {
      stepNavigator.next();
    },
    switchToAci: function () {
      this.showAci(true);
      this.reloadAciWidget();
    },
    switchToStoredCard: function () {
      this.showAci(false);
      this.unloadAciWidget();
    },
    applyForceStoringCardToPaymentForm: function () {
      $('#storeCardForFuture').on('change', function () {
        toggleSubmitButtonOnCheckboxSelection();
      });
      let paymentFormElement = document.getElementById('checkout-step-card-payment');
      if (window.addEventListener) {
        paymentFormElement.addEventListener('DOMSubtreeModified', toggleSubmitButtonOnCheckboxSelection, false);
      }
      function toggleSubmitButtonOnCheckboxSelection() {
        if ($('#storeCardForFuture').is(":checked")) {
          $('.wpwl-button-pay').prop('disabled', false);
        } else {
          $('.wpwl-button-pay').prop('disabled', true);
        }
      }
    },
    executeRetryPayment: function () {
      fullScreenLoader.startLoader();
      this.paymentError(false);
      this.reloadAciWidget();
    }
  });
});

